<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1000px"
      title="人员下发"
      :save-func="()=>{}"
      @create-opened="onCreateOpened"
      @closed="onClosed"
    >
      <template slot="form">
        <div class="index-tree-box">
          <div class="left-box" style="height: calc(100vh - 148px);">
            <div class="left-title">
              <span>设备列表</span>
            </div>
            <div class="left-main">
              <div class="chkitem" v-for="(i,key) in device_list" :key="key">
                <el-checkbox v-model="i.Checked">{{i.DeviceName}}</el-checkbox>
              </div>
            </div>
          </div>
          <div class="right-box" style="padding: 0;border: none;">
            <!-- <div class="row-head right-head">待下发人员信息</div> -->
            
          </div>
        </div>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="save">确 定</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: [],
      params: {
        
      },
      selectRows: [],
      device_list: [],
      isMB: this.$store.state.isMB,
      showForm: !this.$store.state.isMB,
      api: require("@/api/cp/sendlog").default,
      device_api: require("@/api/cp/device").default,
    };
  },
  methods: {
    onCreateOpened(data) {
      console.log("data", data);
      this.device_api.list({ DeviceType: 1 }).then((res) => {
        if (res.Data) {
          this.device_list = res.Data.map((x) => {
            return { ...x, Checked: false };
          });
        }
      });
    },
    
    save() {
      
    },
    onClosed() {
      this.data = [];
      this.selectRows = [];
    },
  },
};
</script>
<style lang="scss">
.index-tree-box {
  .left-main {
    .chkitem {
      line-height: 28px;
      padding-left: 12px;
      .el-checkbox {
        .el-checkbox__label {
          width: 222px;
          overflow: hidden;
          vertical-align: text-bottom;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .right-head {
    font-size: 16px;
    padding-left: 10px;
    border: 1px solid #e4e7ed;
    border-bottom: none;
  }
  .right-tb-head {
    border: 1px solid #e4e7ed;
    border-bottom: none;
    padding: 0 5px 0 10px;
  }
}
.select-row {
  background-color: #f0f9eb !important;
}
</style>